import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Merges updates into the query string; `null` deletes a key. Builds from the FUNCTIONAL
 * `previousParams`, never a render's closure, so two updates in one tick both land (see the
 * comment on `ScheduledActionsTab.updateParams`).
 */
export const useQueryParamUpdater = () => {
  const [, setSearchParams] = useSearchParams()

  return useCallback(
    (updates: Record<string, string | null>) => {
      setSearchParams(
        (previousParams) => {
          const nextParams = new URLSearchParams(previousParams)

          Object.entries(updates).forEach(([key, value]) => {
            if (value === null) {
              nextParams.delete(key)

              return
            }

            nextParams.set(key, value)
          })

          return nextParams
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )
}
